var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_3321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 22.1912C8 20.854 9.20034 19.829 10.538 20.0248C12.2663 20.2771 13.9946 20.5276 15.73 20.7058C20.9843 21.2492 26.2387 21.8878 31.5092 22.156C38.2921 22.5018 45.0928 22.6288 51.8864 22.6447C56.5433 22.6552 61.2091 22.4329 65.8553 22.103C70.8118 21.752 75.7523 21.1751 80.6945 20.6546C82.2926 20.487 83.8853 20.2771 85.4905 20.0636C86.8193 19.8872 88 20.9104 88 22.2354V59.1782C88 60.5031 86.8193 61.5264 85.4905 61.35C83.9138 61.1418 82.3479 60.9354 80.7783 60.7731C75.7059 60.2473 70.6352 59.6704 65.5503 59.3017C57.1301 58.6895 48.6956 58.5096 40.254 58.8024C31.4806 59.1059 22.734 59.7392 14.0338 60.9142C12.8602 61.073 11.6884 61.23 10.5148 61.3888C9.18429 61.567 8 60.5455 8 59.217C8 46.8745 8 34.5338 8 22.1912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1456 73.994V75.2096C65.1456 75.6454 64.7889 76 64.3466 76H31.6521C31.2115 76 30.853 75.6454 30.853 75.2096C30.853 75.0173 30.853 74.8268 30.853 74.6344C30.853 74.4422 30.853 74.2393 30.853 74.0328C30.853 73.5971 31.2097 73.2425 31.6521 73.2425H42.9028C43.3433 73.2425 43.7018 72.8896 43.7018 72.4521V62.3978C43.7018 61.962 44.0585 61.6074 44.5009 61.6074H51.4746C51.9151 61.6074 52.2736 61.9603 52.2736 62.3978V72.4151C52.2736 72.8508 52.6303 73.2054 53.0727 73.2054H64.3484C64.7889 73.2054 65.1474 73.5583 65.1474 73.9958L65.1456 73.994Z",
    fill: "url(#paint0_linear_716_3321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_716_3321",
    x1: 41.1692,
    y1: 64.1766,
    x2: 43.9143,
    y2: 76.2685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01F68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C84DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_3321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 56,
    fill: "white",
    transform: "translate(8 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitors);
export default __webpack_public_path__ + "static/media/monitors.0d491c8181e8109a8fd2fbb3596e5c93.svg";
export { ForwardRef as ReactComponent };